module.exports = __webpack_public_path__ + "static/softool-86cb8eeea249bf7f1566aa44c367c570.svg";